import React from 'react'
import AssignmentIcon from 'components/material-symbol/icons/Assignment'
import EventAvailableIcon from 'components/material-symbol/icons/EventAvailable'
import PeopleIcon from 'components/material-symbol/icons/People'
import PaymentIcon from 'components/material-symbol/icons/Payment'
import coachHeaderImage from 'images/welcome-coach-header.png'
import WelcomeRoleCard from '../welcome-role-card'

export default function PgaCoach() {
  return (
    <WelcomeRoleCard
      testid="pga-coach-login-tile"
      to="/pga-coach"
      audience="For professionals"
      roleTitle="PGA Coach"
      intro="For coaches managing students and coaching programs."
      headerIcon={<AssignmentIcon />}
      headerImage={coachHeaderImage}
      headerImageAlt="PGA Coach instructing a student"
      continueLabel="Continue as PGA Coach"
      features={[
        {
          key: 'fill-schedule',
          icon: <EventAvailableIcon />,
          text: 'Fill your schedule',
        },
        {
          key: 'manage-students',
          icon: <PeopleIcon />,
          text: 'Manage students',
        },
        {
          key: 'get-paid',
          icon: <PaymentIcon />,
          text: 'Get paid and stay organized',
        },
      ]}
    />
  )
}
